const MAX_INT = Number.MAX_SAFE_INTEGER || 99999

export const defaultFormat = {
  allowedChars: /./,
  template: [MAX_INT]
}

export const nameFormat = {
  allowedChars: /[-a-zA-Z. ']/,
  template: [MAX_INT]
}

export const initialsFormat = {
  allowedChars: /[a-zA-Z]/,
  template: [2]
}

export const phoneFormat = {
  allowedChars: /\d/,
  template: ['(',3,') ',3,'-',4]
}

export const emailFormat = {
  allowedChars: /[^\s]/,
  template: [250]
}

export const trackingFormat = {
  allowedChars: /[\d\w]/,
  template: [4,' - ',4,' - ',4,' - ',4]
}

export const fourDigitFormat = {
  allowedChars: /\d/,
  template: [4]
}

export const ccFormat = {
  allowedChars: /\d/,
  template: [4,' ',4,' ',4,' ',4]
}

export const weightFormat = {
  allowedChars: /\d/,
  template: [2,' lbs']
}

export const dateFormat = {
  allowedChars: /\d/,
  template: [2,' / ',2,' / ',4],
}

export const monthYearFormat = {
  allowedChars: /\d/,
  template: [2,' / ',4],
}

export const integerFormat = {
  allowedChars: /\d/,
  template: [MAX_INT],
}

export const decimalFormat = {
  allowedChars: /[\d.]/,
  template: [MAX_INT],
}

export const applyFormat = (format, text) => {
  text = String(text)
  if (!text.length) {
    return { formatted: '', parts:[] }
  }
  const chars = text.match(new RegExp(format.allowedChars.source, 'g')) || []
  let formatted = ''
  let raw = ''
  format.template.forEach(f => {
    if (typeof f === 'string') {
      if (chars.length) {
        formatted += f
      }
    } else {
      const next = chars.splice(0, f).join('')
      formatted += next
      raw += next
    }
  })

  return { formatted, raw }
}